const PICKUP_MANAGEMENT_MODES = {
  CREATE_PICKUP: "createPickup",
  EDIT_PICKUP: "editPickup",
  VOID_PICKUP: "voidPickup",
  MERGE_PICKUP: "mergePickup",
};

const MAX_LENGTH_CONSTRAINTS = {
  CREATE_PICKUP_FORM: {
    ACCOUNT: 7,
    SHIPPER_ADDRESS1: 30,
    SHIPPER_ADDRESS2: 30,
    SHIPPER_CITY: 20,
    SHIPPER_STATE: 2,
    SHIPPER_ZIP: 6,
    SHIPPER_CONTACT_NAME: 30,
    SHIPPER_CONTACT_PHONE: 10,
    SHIPPER_ADDRESS: 30,
    BILL_TO_CODE: 7,
    BILL_TO_NAME: 20,
    QUOTE_NUMBER: 11,
    REFERENCE_NUMBER: 20,
    SPECIAL_INSTRUCTIONS: 600,
    DESTINATION_ZIP: 6,
    PIECES: 5,
    WEIGHT: 7,
    HU: 5,
    ROUTE : 6
  },
  VOID_PICKUP_FORM: {
    COMMENT: 300
  }
};

const MIN_LENGTH_CONSTRAINTS = {
  CREATE_PICKUP_FORM: {
    SHIPPER_NAME : 3,
    DESTINATION_ZIP: 5,
    SHIPPER_ADDRESS: 3,
  }
}

const MAX_VALUE_CONSTRAINTS = {
  CREATE_PICKUP_FORM: {
    SHIPPER_ZIP: 999999,
    PRO_NUMBER: 999999999999,
    DESTINATION_ZIP: 999999,
    PIECES: 99999,
    WEIGHT: 9999999,
    HU: 99999,
    HAZMAT_WEIGHT: 999999,
    EXCESSIVE_LENGTH: 99,
  },
};

const MIN_VALUE = {
  CREATE_PICKUP_FORM: {
    WEIGHT: 1,
    PIECES: 1,
    EXCESSIVE_LENGTH: 1,
    HU: 1,
  },
  DEFAULT: 0,
};

const FORM_VALIDATION_MSG = {
  REQUIRED: "* Required",
  INVALID_PHONE_NUMBER: "Invalid phone number",
  INVALID_EMAIL: "Invalid email",
  MIN_PICKUP_DATE:
    "Pickup date should not be less than in selected terminal's current date",
  MAX_PICKUP_DATE: "Pickup date cannot be more than 7 days in future",
  HU: {
    REQUIRED: "* HU is required",
    INVALID_MAX_VALUE: "* HU max value exceeded",
    INVALID_MIN_VALUE: "* HU min value violated",
  },
  PIECES: {
    REQUIRED: "* Pieces is required",
    INVALID_MAX_VALUE: "* Pieces max value exceeded",
    INVALID_MIN_VALUE: "* Pieces min value violated",
  },
  WEIGHT: {
    REQUIRED: "* Weight is required",
    INVALID_MAX_VALUE: "* Weight max value exceeded",
    INVALID_MIN_VALUE: "* Weight min value violated",
  },
  ZIP_CODE: {
    REQUIRED: "* Zip Code is required",
    INVALID_MAX_VALUE: "* Zip Code max value exceeded",
    INVALID_VALUE: "* Invalid Zip Code",
  },
  PACKAGE_CODE: {
    REQUIRED: "* Package Code is required",
  },
  SEARCH_FIELD_ERROR: {
    TERMINAL_REQUIRED: "Select a terminal to search shipper",
  },
};

export const SEARCH_TYPE = {
  NAME: "name",
  ACCOUNT_CODE: "accountCode",
  PHONE: "phone",
  ADDRESS: "address"
}

const SEARCH_FILTER_OPTIONS = [
  {
    label: "Name",
    value: SEARCH_TYPE.NAME,
  },
  {
    label: "Account Code",
    value: SEARCH_TYPE.ACCOUNT_CODE,
  },
  {
    label: "Phone #",
    value: SEARCH_TYPE.PHONE,
  },
  {
    label: "Address",
    value: SEARCH_TYPE.ADDRESS,
  },
];

const EDIT_REASON_OPTIONS = [
  { value: "2", labelText: "Customer change request" },
  { value: "1", labelText: "Saia missed pickup" },
];

const WARNING_DETAILS= {
  DESTINATION_LABEL: "Destination Warning",
  SHIPPER_LABEL: "Shipper Warning",
  DESTINATION_DESCRIPTION: "Do not accept shipment unless the customer can provide a valid Saia Account code number.",
  SHIPPER_DESCRIPTION: "Do not accept shipment unless the customer can provide a valid Saia Account code number.",
  WARNING_LABELS: {
    CREATE: "Continue create pickup",
    EDIT: "Continue edit pickup",
    MERGE: "Continue merge pickup",
  }
}

const ORDERERD_FIELD_LIST = [
  "shipperContactPhone",
  "shipperEmail",
  "shipperName",
  "shipperZip",
  "shipperAddress1",
  "readyTime",
  "closeTime",
  "pickupDate",
  "editReasonCode",
  "contactName",
  "callTime",
  "comments",
]

export {
  MAX_LENGTH_CONSTRAINTS,
  MIN_VALUE,
  MAX_VALUE_CONSTRAINTS,
  FORM_VALIDATION_MSG,
  PICKUP_MANAGEMENT_MODES,
  SEARCH_FILTER_OPTIONS,
  EDIT_REASON_OPTIONS,
  WARNING_DETAILS,
  ORDERERD_FIELD_LIST,
  MIN_LENGTH_CONSTRAINTS
};
